// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */

import * as RescriptRelay from "rescript-relay/src/RescriptRelay.bs.js";
import * as RelayAppSync__AWSJSON from "../../relay-appsync/src/RelayAppSync__AWSJSON.bs.js";

var Types = {};

var variablesConverter = {"__root":{"input":{"c":"RelayAppSync.AWSJSON"}}};

var variablesConverterMap = {
  "RelayAppSync.AWSJSON": RelayAppSync__AWSJSON.serialize
};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, variablesConverterMap, undefined);
}

var wrapResponseConverter = {"__root":{"createRowJSON":{"c":"RelayAppSync.AWSJSON"}}};

var wrapResponseConverterMap = {
  "RelayAppSync.AWSJSON": RelayAppSync__AWSJSON.serialize
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

var responseConverter = {"__root":{"createRowJSON":{"c":"RelayAppSync.AWSJSON"}}};

var responseConverterMap = {
  "RelayAppSync.AWSJSON": RelayAppSync__AWSJSON.parse
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

var Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: variablesConverterMap,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

var Utils = {};

var node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "json",
            "variableName": "input"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "createRowJSON",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SpacesRowMutationsCreateRowJSONMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SpacesRowMutationsCreateRowJSONMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e0a79b592fd0de2dceacc6e7f55123c3",
    "id": null,
    "metadata": {},
    "name": "SpacesRowMutationsCreateRowJSONMutation",
    "operationKind": "mutation",
    "text": "mutation SpacesRowMutationsCreateRowJSONMutation(\n  $input: AWSJSON!\n) {\n  createRowJSON(input: {json: $input})\n}\n"
  }
};
})());

export {
  Types ,
  Internal ,
  Utils ,
  node ,
}
/* node Not a pure module */
